<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cp0GQi/tc-custom/9781250207722.jpg?1731166637805" alt="This image is the cover for the book Skripal Files"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Skripal Files
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The explosive story of the poisoning of the former Russian spy Sergei Skripal and what it reveals about the growing clandestine conflict between the West and Russia</b><br/><br/>Salisbury, England: March 4, 2018.<br/><br/>Slumped on a bench, paralyzed and barely able to breathe, were a former Russian intelligence officer named Sergei Skripal and his daughter, Yulia. Sergei had been living a quiet life in England since 2010, when he was expelled from Russia as part of a spy swap; he had been serving a lengthy prison sentence for working secretly for the British intelligence agency MI6. On this Sunday afternoon, he and his daughter had just finished lunch at a local restaurant when they started to feel faint. Within minutes they were close to death.<br/><br/>The Skripals had been poisoned, not with a familiar toxin but with Novichok, a deadly nerve agent developed in southern Russia. Was this a message from the Kremlin that traitors would not escape violent death, even on British soil? As Sergei and Yulia fought for their lives, and the British government and their allies sought answers, relations between the West and Russia descended to a new low.<br/><i><br/>The Skripal Files</i> is a remarkable and definitive account of Sergei Skripal’s story, which lays bare the new spy war between Russia and the West. Mark Urban, the diplomatic and defense editor for the BBC, met with Skripal in the months before his poisoning, learning about his career in Russian military intelligence, how he became a British agent, his imprisonment in Russia, and the events that led to his release. Skripal’s first-hand accounts and experiences reveal the high stakes of a new spy game that harks back to the chilliest days of the Cold War.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Urban
      </h2>
      
      <p class="authorDescription body article"><B>Mark Urban</B> is Diplomatic and Defense Editor of the BBC’s <I>Newsnight</I>. He has covered many of the world’s conflicts during the past twenty-five years, including the Iraq campaign that began in 2003. He is the author of <I>The Skripal Files</I>. He lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?664f525a